import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PipelineFormLayoutProps {
    isEditing: boolean;
    pipelineType?: string;
    children: React.ReactNode;
}

const getPipelineTypeName = (type: string | undefined): string => {
    switch (type) {
        case 'ga4-sessionization':
            return 'GA4 Sessionization';
        case 'ga4-flattener':
            return 'GA4 Flattener';
        case 'marketing-attribution':
            return 'Marketing Attribution';
        case 'google-ads-cost-loader':
            return 'Google Ads Cost Loader';
        default:
            return '';
    }
};

export const PipelineFormLayout: React.FC<PipelineFormLayoutProps> = ({ isEditing, pipelineType, children }) => {
    const navigate = useNavigate();
    const typeName = getPipelineTypeName(pipelineType);
    const title = isEditing 
        ? (typeName ? `Edit Pipeline - ${typeName}` : 'Edit Pipeline')
        : (typeName ? `Create Pipeline - ${typeName}` : 'Create Pipeline');

    return (
        <div className="pipeline-configuration">
            <div className="header">
                <h2>{title}</h2>
                <button onClick={() => navigate('/pipelines')} className="back-button">Back</button>
            </div>
            {children}
        </div>
    );
};
